import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function SystemCard({ s, index = 0 }) {
  return (
    <Link
      to={s.path}
      data-testid={`system-card-${s.slug}`}
      className="surface group block reveal"
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      <div className="aspect-[4/3] overflow-hidden border-b border-[rgba(255,255,255,0.08)] relative">
        <img
          src={s.image}
          alt={s.name}
          className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050607] via-transparent to-transparent" />
        <div className="absolute top-4 left-4 overline">{s.code} / SYSTEM</div>
      </div>
      <div className="p-6 md:p-8">
        <div className="flex items-baseline justify-between gap-4">
          <h3 className="font-display text-2xl md:text-3xl uppercase">{s.name}</h3>
          <ArrowUpRight
            size={20}
            strokeWidth={1.5}
            className="text-[#AEB7B7] group-hover:text-[#18E096] transition-colors"
          />
        </div>
        <div className="text-[#18E096] text-xs uppercase tracking-[0.2em] mt-1">{s.subtitle}</div>
        <p className="text-[#AEB7B7] text-sm leading-relaxed mt-4">{s.short}</p>
        {s.formula && (
          <p className="text-white text-sm mt-3 font-medium border-l border-[#18E096] pl-3">
            {s.formula}
          </p>
        )}
        <div className="mt-6 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white group-hover:text-[#18E096] transition-colors">
          {s.cta} <ArrowUpRight size={14} strokeWidth={1.5} />
        </div>
      </div>
    </Link>
  );
}
